import { AdjustNote, AdjustSlider } from '../AdjustControlPrimitives.component'
import { BLUR_BRUSH_SIZE_RANGE, BLUR_STRENGTH_MAX, BLUR_STRENGTH_MIN } from '../adjust.types'

import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined'
import CropFreeIcon from '@mui/icons-material/CropFree'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { FC } from 'react'
import { LabSegmented } from '../../lab/LabPanelPrimitives.component'
import { MUIButton } from 'components/common/MUIButton'
import { Stack } from '@mui/material'
import { useAdjustEditor } from '../AdjustEditor.context'
import { useTranslation } from 'react-i18next'

/** Area (today's rectangle blur) or Brush, each with its own default strength on the 1…10 scale */
export const BlurControls: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const { t } = useTranslation(['photo_studio_editing'])
  const { doc, apply, blurMode, setBlurMode, blurStrength, setBlurStrength, blurBrushSize, setBlurBrushSize } = useAdjustEditor()

  return (
    <Stack gap="1.2rem">

      <LabSegmented
        ariaLabel={t('adjust.blur.mode_label')}
        disabled={disabled}
        value={blurMode}
        onChange={setBlurMode}
        options={[
          { value: 'area', label: t('adjust.blur.mode.area'), icon: <CropFreeIcon /> },
          { value: 'brush', label: t('adjust.blur.mode.brush'), icon: <BrushOutlinedIcon /> },
        ]}
      />

      {blurMode === 'brush' && (
        <AdjustSlider
          label={t('adjust.blur.brush_size')}
          value={blurBrushSize}
          valueLabel={String(blurBrushSize)}
          min={BLUR_BRUSH_SIZE_RANGE.min}
          max={BLUR_BRUSH_SIZE_RANGE.max}
          disabled={disabled}
          onChange={setBlurBrushSize}
        />
      )}

      <AdjustSlider
        label={t('adjust.blur.strength')}
        value={blurStrength}
        valueLabel={String(blurStrength)}
        min={BLUR_STRENGTH_MIN}
        max={BLUR_STRENGTH_MAX}
        disabled={disabled}
        onChange={setBlurStrength}
      />

      <AdjustNote>{t(blurMode === 'area' ? 'adjust.blur.hint_area' : 'adjust.blur.hint_brush')}</AdjustNote>

      <MUIButton type="secondaryBorder" size="sm" startIcon={<DeleteOutlineIcon />} disabled={disabled || !doc.blurs.length} onClick={() => apply({ type: 'clearBlurs' })}>
        {t('adjust.blur.clear', { count: doc.blurs.length })}
      </MUIButton>

    </Stack>
  )
}
